import React from 'react';
import ContactForm from './ContactForm';
import { supportInfo } from '../mock';

const HomePage = () => {
  return (
    <div className="min-h-screen w-full bg-[#eae8e0] flex items-center justify-center px-4 py-12 md:py-20">
      <main
        className="w-full max-w-2xl bg-white shadow-[0_2px_20px_rgba(0,0,0,0.04)] px-6 sm:px-10 md:px-16 py-12 md:py-16"
        style={{ borderRadius: 2 }}
      >
        {/* Brand Header */}
        <header className="text-center">
          <h1
            className="font-serif text-[#1f1d1a] tracking-[0.18em] text-2xl sm:text-3xl md:text-4xl font-semibold"
            style={{ fontFamily: "'Playfair Display', 'Cormorant Garamond', Georgia, serif" }}
          >
            CEDAR &amp; ASH
          </h1>
          <div className="mx-auto mt-4 w-14 h-px bg-[#b8a88a]" />
        </header>

        {/* Headline */}
        <section className="mt-10 text-center">
          <h2 className="font-serif text-[#1f1d1a] text-xl sm:text-2xl md:text-[26px] font-bold leading-snug">
            We are no longer accepting orders at this time.
          </h2>
        </section>

        {/* Body copy */}
        <section className="mt-7 text-[#3a3832] text-[15px] md:text-base leading-[1.9] text-center max-w-xl mx-auto">
          <p>
            <strong className="font-semibold text-[#1f1d1a]">
              While we&apos;ve paused sales, we remain committed to supporting all
              existing customers.
            </strong>{' '}
            If you need assistance with a past order or have any questions,
            please don&apos;t hesitate to reach out using the contact details
            below. Please note that all active memberships have been cancelled
            as part of this transition, and no further charges will be made.
          </p>
        </section>

        {/* Support Contact Block */}
        <section className="mt-10 bg-[#f3f1e9] px-6 sm:px-8 py-6 sm:py-7">
          <h3 className="text-xs font-bold tracking-[0.24em] uppercase text-[#1f1d1a]">
            Support Contact
          </h3>
          <div className="mt-4 space-y-2 text-[15px] text-[#3a3832]">
            <p>
              Email:{' '}
              <a
                href={`mailto:${supportInfo.email}`}
                className="underline decoration-[#b8a88a] decoration-1 underline-offset-4 hover:text-[#1f1d1a] transition-colors"
              >
                {supportInfo.email}
              </a>{' '}
              <span className="text-[#6b6659]">({supportInfo.emailHours})</span>
            </p>
            <p>
              Phone:{' '}
              <a
                href={`tel:${supportInfo.phone.replace(/[^0-9]/g, '')}`}
                className="hover:text-[#1f1d1a] transition-colors"
              >
                {supportInfo.phone}
              </a>{' '}
              &ndash;{' '}
              <span className="text-[#6b6659]">{supportInfo.phoneHours}</span>
            </p>
          </div>
        </section>

        {/* Contact Form */}
        <ContactForm />
      </main>
    </div>
  );
};

export default HomePage;
